/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Coach_TitleInputs */

const en_portal_coach_title = /** @type {(inputs: Portal_Coach_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you the coach?`)
};

const pl_portal_coach_title = /** @type {(inputs: Portal_Coach_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jesteś trenerem?`)
};

/**
* | output |
* | --- |
* | "Are you the coach?" |
*
* @param {Portal_Coach_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_coach_title = /** @type {((inputs?: Portal_Coach_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Coach_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_coach_title(inputs)
	return en_portal_coach_title(inputs)
});